import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { api } from '../../libs/axios';
import { Bilhete, Pedido } from '../../utils/interfaces';

interface UsePedidoProps {
  id: string;
}

type ResponseUsePedido = {
  pedido: Pedido;
  bilhetes: Bilhete[]
};

type PedidoDetalhesError = {
  message?: string;
  data?: {
    message?: string;
    redirect_to?: string;
    redirect_to_home?: boolean;
    error_type?: string;
  };
};

async function getPedido({ id }: UsePedidoProps): Promise<ResponseUsePedido> {
  try {
    const response = await api.get(`/pedido/detalhes/${id}`).then((res: AxiosResponse) => {
      return res.data;
    });

    const pedido = response.pedido;
    const bilhetes = response.bilhetes;

    return {
      pedido,
      bilhetes,
    };
  } catch (error) {
    const axiosError = error as AxiosError<PedidoDetalhesError>;
    const shouldRedirect = axiosError.response?.data?.data?.redirect_to_home;

    if (shouldRedirect) {
      const redirectTo = axiosError.response?.data?.data?.redirect_to || '/';
      window.location.href = redirectTo;
    }

    throw error;
  }
}

export function usePedidoDetalhes({ id }: UsePedidoProps) {
  return useQuery({
    queryKey: ['pedido-detalhes', { id }],
    queryFn: () => getPedido({ id }),
    staleTime: 1,
    gcTime: 1,
    retry: false,
});
}